module.exports = __webpack_public_path__ + "img/station-array-warning.14278b71.png";